// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"CurrencyDropdownMenu_dropdown__2qxH2"};